import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindPromiseCreators } from 'redux-saga-routines';
import { reduxForm, Field, Form } from 'redux-form/immutable';
import { fromJS } from 'immutable';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { getDialogContextValue } from '../../../redux/selectors';
import { toJS } from '../../../utils/helper';

import ReduxDialog from '../../Common/ReduxDialog/index';

import {
  sendTaskSmsFormHandler
} from '../../../redux/routines';

import { showDialog, hideDialog, showError } from '../../../redux/actions/dialogs';
import {
  renderTextField
} from '../../../utils/reduxforms';
import {
  SEND_SMS_DIALOG,
} from '../../../redux/constants/dialogs';

import styles from './styles';

class SendSmsDialog extends Component {
  render() {
    const { handleSubmit, hideDialog, submit } = this.props;

    const actions = [
      <Button
        key="cancel"
        variant="text"
        onClick={() => hideDialog(SEND_SMS_DIALOG)}
      >Cancel</Button>,
      <Button
        key="send"
        variant="contained"
        color="primary"
        autoFocus
        onClick={() => submit(SEND_SMS_DIALOG)}
      >Send</Button>];

    return (
      <ReduxDialog
        name={SEND_SMS_DIALOG}
        title="Send SMS"
        actions={actions}
        bodyStyle={styles.body}
        fullWidth
        maxWidth="sm"
      >
        <Form onSubmit={handleSubmit(sendTaskSmsFormHandler)} style={styles.container}>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <Field
                name="to"
                label="To"
                component={renderTextField}
                disabled
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <Field
                name="body"
                label="Body"
                component={renderTextField}
                fullWidth
                rows={3}
                multiline
              />
            </Grid>
          </Grid>
        </Form>
      </ReduxDialog>
    );
  }
}

SendSmsDialog.propTypes = {
  // contact: PropTypes.object.isRequired,
};

const form = reduxForm({
  form: SEND_SMS_DIALOG,  // a unique identifier for this form
  onSubmitSuccess: (result, dispatch, props) => {
    props.hideDialog(SEND_SMS_DIALOG);
  },
})(SendSmsDialog);

function mapStateToProps(state, props) {
  // console.log('state', state);
  const contact = getDialogContextValue(state)(SEND_SMS_DIALOG, 'contact').toJS();
  console.log('contact', contact);
  return {
    initialValues: fromJS({
      to: contact.mobile.number,
      params: toJS(getDialogContextValue(state)(SEND_SMS_DIALOG, 'params')),
    }),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      showDialog,
      hideDialog,
      showError,
    }, dispatch),
    ...bindPromiseCreators({
      // saveCustomerLogo: saveCustomerLogoPromise,
    }, dispatch)
  };

}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Common/SendSmsDialog/index.js